import type { ReactNode } from 'react';

interface PageHeadProps {
  title: string;
  sub?: string;
  meta?: ReactNode;
  actions?: ReactNode;
}

export function PageHead({ title, sub, meta, actions }: PageHeadProps) {
  return (
    <div className="page-head">
      <div>
        <h1 className="page-title">{title}</h1>
        {sub && <p className="page-sub">{sub}</p>}
        {meta && <div className="page-meta">{meta}</div>}
      </div>
      {actions && <div className="page-actions">{actions}</div>}
    </div>
  );
}
